import { useEffect, useState } from 'react'
import { demonstrativoMetaFamiliaServiceByDateAndId } from '../services/demonstrativo-meta-familia.service'
import type { DemonstrativoMetaFamilia } from '../types/demonstrativo-meta-familia'

export interface DemonstrativoMetaFamiliaParams {
  idSemana: number
  iniDate: string
  endDate: string
}

export function useDemonstrativoMetaFamila({
  idSemana,
  iniDate,
  endDate,
}: DemonstrativoMetaFamiliaParams) {
  const [dataDemonstrativoMetaFamila, setDataDemonstrativoMetaFamila] =
    useState<DemonstrativoMetaFamilia[]>([])
  const [
    isLoadingDemonstrativoMetaFamila,
    setIsLoadingDemonstrativoMetaFamila,
  ] = useState(false)

  const handleFetchDemonstrativoMetaFamila = async (
    id: number,
    iniDate: string,
    endDate: string,
  ) => {
    try {
      setIsLoadingDemonstrativoMetaFamila(true)

      const { body } = await demonstrativoMetaFamiliaServiceByDateAndId({
        id,
        iniDate,
        endDate,
      })

      let demonstrativoMetaFamilia: DemonstrativoMetaFamilia[]

      try {
        demonstrativoMetaFamilia = JSON.parse(body)
      } catch (error) {
        console.error('Erro ao fazer parse do JSON:', error)
        return
      }

      setDataDemonstrativoMetaFamila(
        Array.isArray(demonstrativoMetaFamilia)
          ? demonstrativoMetaFamilia
          : [demonstrativoMetaFamilia],
      )
    } catch (error) {
      console.error('Erro ao buscar demonstrativo meta familia:', error)
    } finally {
      setIsLoadingDemonstrativoMetaFamila(false)
    }
  }

  useEffect(() => {
    if (!idSemana || !iniDate || !endDate) {
      return
    }

    handleFetchDemonstrativoMetaFamila(idSemana, iniDate, endDate)
  }, [idSemana, iniDate, endDate])

  return {
    dataDemonstrativoMetaFamila,
    handleFetchDemonstrativoMetaFamila,
    idSemana,
    isLoadingDemonstrativoMetaFamila,
  }
}
